import AppealsPage from "./ui/AppealsPage.vue";
export default AppealsPage;
